import { Grid, makeStyles } from "@material-ui/core"
import { createContext, useEffect, useState } from "react"

import { useSnackbar } from "notistack"
import { useParams } from "react-router-dom/cjs/react-router-dom"
import {
    cadastrarCategoria,
    cadastrarGrupoDeOpcao,
    cadastrarImagem,
    cadastrarOpcao,
    cadastrarProduto,
    duplicarCategoria,
    duplicarGrupoDeOpcao,
    duplicarProduto,
    excluirCategoria,
    excluirGrupoDeOpcao,
    excluirOpcao,
    excluirProduto,
    obterCardapioParaEdicaoEmMassa,
    salvarCardapioCompleto,
} from "../../services/cardapio"
import { ObterCardapioNovo } from "../../services/clientefiel"
import {
    atualizarFichaTecnica,
    buscarFichaTecnicaOpcao,
    buscarFichaTecnicaProduto,
    buscarFihcasTecnicas,
    salvarFichaTecnica,
} from "../../services/fichaTecnica"
import { buscarInsumos } from "../../services/insumos"
import useAppStore from "../../stores/AppStore"
import useLoadingStore from "../../stores/LoadingStore"
import Cabecalho from "../Cabecalho"
import { CheckboxProvider } from "./componentes/CheckboxContext"
import EdicaoEmMassa from "./componentes/EdicaoEmMassa"
import FichaTecnica from "./componentes/fihcaTecnica"
import Inusmos from "./componentes/Inusmos"
import NovaTelaProdutos from "./componentes/NovaTelaProdutos"

const useStyles = makeStyles(() => ({
    container: {
        display: "flex",
        justifyContent: "center",
        "@media (max-width: 400px)": {
            marginTop: "12em",
        },
    },
}))

let idsSave = []
export const Sincronizacao99Context = createContext()

export default function CardapioNovo({ estabelecimento }) {
    const autorizacao = localStorage.getItem("chaveSistema")
    const classes = useStyles()
    const setLoading = useLoadingStore(s => s.setLoading)

    const { enqueueSnackbar } = useSnackbar()
    const alertStart = (msg, tipo) => {
        enqueueSnackbar(msg, { variant: tipo })
    }

    const { tela } = useParams()

    const [cadastrar, setCadastrar] = useState(true)
    const [cardapio, setCardapio] = useState()
    const [categorias, setCategorias] = useState()
    const [items, setItems] = useState()
    const [insumos, setInsumos] = useState([])
    const [FTEstabelecimento, setFTEstabelecimento] = useState()

    useEffect(() => {
        const buscarCardapioProduto = async () => {
            setLoading(true)
            try {
                const response = await ObterCardapioNovo(autorizacao, {
                    idEstabelecimento: estabelecimento?.id,
                    token: "a~I?;;+_@!AL^",
                })

                if (response.retornoErro) {
                    alertStart(response.mensagem, "error")
                } else {
                    setCardapio(response)
                    setCategorias(response.categorias)
                }
            } catch {
                console.log("Erro ao buscar Cardápio")
            } finally {
                setLoading(false)
            }
        }
        const buscarCardapioMassa = async () => {
            setLoading(true)
            try {
                const response = await obterCardapioParaEdicaoEmMassa(
                    estabelecimento?.id,
                    autorizacao
                )
                if (response.retornoErro) {
                    alertStart(response.mensagem, "error")
                    return false
                } else {
                    setItems(response)
                }
            } catch {
                console.log("Erro ao buscar Cardápio")
            } finally {
                setLoading(false)
            }
        }
        const buscarInusmos = async () => {
            setLoading(true)
            try {
                const response = await buscarInsumos(estabelecimento?.id, autorizacao)
                if (response.retornoErro === 1) {
                    console.log("Erro ao buscar Inusmos => ", response.retornoErro)
                    return setInsumos([])
                }
                setInsumos(response)
                buscarCardapioProduto()
            } catch {
                console.log("Erro ao buscar Inusmos")
            } finally {
                setLoading(false)
            }
        }
        const buscarFichaTecnica = async () => {
            setLoading(true)
            try {
                const response = await buscarFihcasTecnicas(estabelecimento?.id, autorizacao)
                if (response.retornoErro) {
                    alertStart(response.mensagem, "error")
                    return false
                } else {
                    setFTEstabelecimento(response)
                    buscarInusmos()
                    buscarCardapioProduto()
                }
            } catch {
                console.log("Erro ao buscar Cardápio")
            } finally {
                setLoading(false)
            }
        }

        if (tela === "produtos") {
            buscarCardapioProduto()
        } else if (tela === "massa") {
            buscarCardapioMassa()
        } else if (tela === "insumos") {
            buscarInusmos()
        } else if (tela === "ficha-tecnica") {
            buscarFichaTecnica()
        }
    }, [tela])

    const handleSalvarCategoria = async data => {
        setLoading(true)
        const response = await cadastrarCategoria(cardapio?.id, data, autorizacao)

        if (response.retornoErro) {
            console.error(response)
            alertStart(response.mensagem, "error")
        } else {
            if (cadastrar) {
                setCategorias(prev => [...prev, response])
                alertStart("Categoria cadastrada com sucesso", "success")
            } else {
                setCategorias(prev => prev.map(cat => (cat.id === data.id ? response : cat)))
                alertStart("Categoria editada com sucesso", "success")
            }
            console.warn("CadastrarCategoria => ", response)
        }
        setLoading(false)
    }
    let mudarCategoria = false

    const handleSalvarProduto = async (idCategoria, data) => {
        setLoading(true)

        const categoriaProduto = categorias.findIndex(c => c.id === idCategoria)

        if (categorias[categoriaProduto]?.produtos.findIndex(c => c.id === data.id) === -1) {
            mudarCategoria = true
        }

        const response = await cadastrarProduto(idCategoria, data, autorizacao)

        if (response.retornoErro) {
            setLoading(false)
            console.error(response)
            alertStart(response.mensagem, "error")
            return false
        } else {
            if (cadastrar) {
                if (categoriaProduto === -1) return categorias

                setCategorias(prev =>
                    prev.map(cat =>
                        cat.id === idCategoria
                            ? { ...cat, produtos: [...cat.produtos, response] }
                            : cat
                    )
                )
                alertStart("Produto cadastrado com sucesso", "success")
            } else if (mudarCategoria) {
                setCategorias(prev =>
                    prev?.map(cat => {
                        if (cat.produtos.some(produto => produto.id === data.id)) {
                            return {
                                ...cat,
                                produtos: cat.produtos.filter(produto => produto.id !== data.id),
                            }
                        } else if (cat.id === idCategoria) {
                            return {
                                ...cat,
                                produtos: [...cat.produtos, response],
                            }
                        }
                        return cat
                    })
                )
                alertStart("Produto editado com sucesso", "success")
            } else {
                if (!response?.urlImagem) {
                    const el = document.getElementById(`imagemProduto${response?.id}`)
                    el?.remove()
                }
                document.getElementById(`nomeProduto${response.id}`).value = response.nome
                document.getElementById(`ordemExibProduto${response.id}`).value = response.ordemExib
                document.getElementById(`descricaoProduto${response.id}`).value = response.descricao
                document.getElementById(`valorProduto${response.id}`).value = response.valor
                alertStart("Produto editado com sucesso", "success")
            }

            console.warn("CadastrarProduto => ", response)
        }

        mudarCategoria = false
        setLoading(false)
        return true
    }

    const handleCadastrarGrupoDeOpcao = async (idProduto, data) => {
        setLoading(true)
        const categoriaIndex = categorias.findIndex(categoria =>
            categoria.produtos.some(produto => produto.id === idProduto)
        )

        const catId = categorias[categoriaIndex].id
        if (categoriaIndex === -1) {
            console.error("Categoria não encontrada.")
            return
        }

        const produtoIndex = categorias[categoriaIndex].produtos.findIndex(
            produto => produto.id === idProduto
        )
        if (produtoIndex === -1) {
            console.error("Produto não encontrado.")
            return
        }

        const response = await cadastrarGrupoDeOpcao(idProduto, data, autorizacao)

        if (response.retornoErro) {
            setLoading(false)
            alertStart(response.mensagem, "error")
            console.error(response)
        } else {
            if (cadastrar) {
                setCategorias(prev =>
                    prev.map(cat =>
                        cat.id === catId
                            ? {
                                  ...cat,
                                  produtos: cat.produtos.map(prod =>
                                      prod.id === idProduto
                                          ? {
                                                ...prod,
                                                opcoes: [...prod.opcoes, response],
                                            }
                                          : prod
                                  ),
                              }
                            : cat
                    )
                )

                alertStart("Passo de montagem cadastrado com sucesso", "success")
            } else {
                setCategorias(prev =>
                    prev.map(cat =>
                        cat.id === catId
                            ? {
                                  ...cat,
                                  produtos: cat.produtos.map(prod =>
                                      prod.id === idProduto
                                          ? {
                                                ...prod,
                                                opcoes: prod.opcoes.map(opcao =>
                                                    opcao.id === data.id ? response : opcao
                                                ),
                                            }
                                          : prod
                                  ),
                              }
                            : cat
                    )
                )

                alertStart("Passo de montagem editado com sucesso", "success")
            }

            console.warn("CadastrarGrupoDeOpcao => ", response)
        }
        setLoading(false)
    }

    const handleCadastrarOpcao = async (idProduto, idPasso) => {
        setLoading(true)

        const categoriaIndex = categorias.findIndex(categoria =>
            categoria.produtos.some(produto => produto.id === idProduto)
        )
        if (categoriaIndex === -1) {
            console.error("Categoria não encontrada.")
            return
        }

        const produtoIndex = categorias[categoriaIndex].produtos.findIndex(
            produto => produto.id === idProduto
        )
        if (produtoIndex === -1) {
            console.error("Produto não encontrado.")
            return
        }

        const passoIndex = categorias[categoriaIndex].produtos[produtoIndex].opcoes.findIndex(
            passo => passo.id === idPasso
        )
        if (passoIndex === -1) {
            console.error("passo não encontrado.")
            return
        }

        const data = {
            nome: "Nova opção",
            valor: "",
            codigo: "",
            descricao: "",
            ativo: true,
            ordemExib: 0,
            informativo: false,
            tipoProducao: null,
            impressaoAlternada: 0,
        }

        const response = await cadastrarOpcao(idPasso, data, autorizacao)

        if (response.retornoErro) {
            console.error(response)
            alertStart(response.mensagem, "error")
        } else {
            console.warn("cadastrarOpcao => ", response)
            setCategorias(prev => {
                const updatedCategorias = [...prev]
                updatedCategorias[categoriaIndex].produtos[produtoIndex].opcoes[
                    passoIndex
                ].opcoes.push(response)
                return updatedCategorias
            })
            alertStart("Opção cadastrada com sucesso", "success")
        }

        setLoading(false)
    }

    const handleDuplicarCategoria = async idCategoria => {
        setLoading(true)
        const data = { id: idCategoria }

        const response = await duplicarCategoria(data, autorizacao)

        if (response.retornoErro) {
            setLoading(false)
            alertStart(response.mensagem, "error")
            console.error(response)
        } else {
            setCategorias(prev => {
                categorias.push(response)
                return [...prev]
            })
            console.warn("DuplicarCategoria => ", response)
            alertStart("Categoria duplicada com sucesso", "success")
        }
        setLoading(false)
    }

    const handleDuplicarProduto = async (idProduto, idCategoria) => {
        setLoading(true)
        const categoriaProduto = categorias.findIndex(c => c.id === idCategoria)

        if (categorias[categoriaProduto]?.produtos?.findIndex(c => c.id === idProduto) === -1) {
            mudarCategoria = true
        }

        const data = { id: idProduto }

        const response = await duplicarProduto(data, autorizacao)
        if (response.retornoErro) {
            setLoading(false)
            alertStart(response.mensagem, "error")
            console.error(response)
        } else {
            if (categoriaProduto === -1) return categorias
            delete response.md5Imagem
            delete response.impressaoEmSeparado
            delete response.tipo
            delete response.idCategoria
            delete response.categoriaTemp
            setCategorias(prev => {
                prev[categoriaProduto]?.produtos?.push(response)
                return [...prev]
            })
            console.warn("DuplicarProduto => ", response)
            alertStart("Produto duplicado com sucesso", "success")
        }
        setLoading(false)
    }

    const handleDuplicarPassoDeMontagem = async (idProduto, idPasso) => {
        setLoading(true)
        const categoriaIndex = categorias.findIndex(categoria =>
            categoria.produtos.some(produto => produto.id === idProduto)
        )
        if (categoriaIndex === -1) {
            console.error("Categoria não encontrada.")
            return
        }

        const produtoIndex = categorias[categoriaIndex].produtos.findIndex(
            produto => produto.id === idProduto
        )
        if (produtoIndex === -1) {
            console.error("Produto não encontrado.")
            return
        }

        const data = { id: idPasso }

        const response = await duplicarGrupoDeOpcao(data, idProduto, autorizacao)
        if (response.retornoErro) {
            setLoading(false)
            alertStart(response.mensagem, "error")
            console.error(response)
        } else {
            setCategorias(prev => {
                const updatedCategorias = [...prev]
                updatedCategorias[categoriaIndex].produtos[produtoIndex].opcoes.push(response)
                return updatedCategorias
            })
            console.warn("DuplicarGrupoDeOpcao => ", response)
            alertStart("Passo de montagem duplicado com sucesso", "success")
        }
        setLoading(false)
    }

    const handleExcluirCategoria = async idCategoria => {
        setLoading(true)
        const data = { id: idCategoria }

        const response = await excluirCategoria(data, autorizacao)

        if (response.retornoErro) {
            setLoading(false)
            alertStart(response.mensagem, "error")
            console.error(response)
        } else {
            setCategorias(prev => {
                return prev.filter(item => item.id !== idCategoria)
            })
            console.warn("ExcluirCategoria => ", response)
            alertStart("Categoria excluída com sucesso", "success")
        }
        setLoading(false)
    }

    const handleExcluirProduto = async (idProduto, idCategoria) => {
        setLoading(true)
        const categoriaProduto = categorias.findIndex(c => c.id === idCategoria)

        if (categoriaProduto === -1) {
            console.warn("Produto não encontrado ")
            return
        }
        const produtoIndex = categorias[categoriaProduto]?.produtos?.findIndex(
            p => p.id === idProduto
        )
        if (produtoIndex === -1) {
            console.warn("Produto não encontrado ")
            return
        }

        const data = { id: idProduto }
        const response = await excluirProduto(data, autorizacao)

        if (response.retornoErro) {
            setLoading(false)
            alertStart(response.mensagem, "error")
            console.error(response)
        } else {
            setCategorias(prev => {
                const updatedCategorias = [...prev]
                updatedCategorias[categoriaProduto].produtos = updatedCategorias[
                    categoriaProduto
                ].produtos.filter(p => p.id !== idProduto)
                return updatedCategorias
            })
            console.warn("ExcluirProduto => ", response)
            alertStart("Produto excluído com sucesso", "success")
        }
        setLoading(false)
    }

    const handleExcluirGrupoDeOpcao = async (idProduto, idGrupoOpcao) => {
        setLoading(true)
        const categoriaIndex = categorias.findIndex(categoria =>
            categoria.produtos.some(produto => produto.id === idProduto)
        )
        if (categoriaIndex === -1) {
            console.error("Categoria não encontrada.")
            return
        }

        const produtoIndex = categorias[categoriaIndex].produtos.findIndex(
            produto => produto.id === idProduto
        )
        if (produtoIndex === -1) {
            console.error("Produto não encontrado.")
            return
        }

        const data = { id: idGrupoOpcao }

        const response = await excluirGrupoDeOpcao(data, autorizacao)

        if (response.retornoErro) {
            setLoading(false)
            alertStart(response.mensagem, "error")
            console.error(response)
        } else {
            setCategorias(prev => {
                const updatedCategorias = [...prev]
                updatedCategorias[categoriaIndex].produtos[produtoIndex].opcoes = updatedCategorias[
                    categoriaIndex
                ].produtos[produtoIndex].opcoes.filter(o => o.id !== idGrupoOpcao)
                return updatedCategorias
            })
            console.warn("ExcluirGrupoDeOpcao => ", response)
            alertStart("Passo de montagem excluído com sucesso", "success")
        }
        setLoading(false)
    }

    const handleExcluirOpcao = async (idProduto, idPasso, idOpcao, index) => {
        const categoriaIndex = categorias.findIndex(categoria =>
            categoria.produtos.some(produto => produto.id === idProduto)
        )
        if (categoriaIndex === -1) {
            console.error("Categoria não encontrada.")
            return
        }

        const produtoIndex = categorias[categoriaIndex].produtos.findIndex(
            produto => produto.id === idProduto
        )
        if (produtoIndex === -1) {
            console.error("Produto não encontrado.")
            return
        }

        const passoIndex = categorias[categoriaIndex].produtos[produtoIndex].opcoes.findIndex(
            passo => passo.id === idPasso
        )
        if (passoIndex === -1) {
            console.error("Passo não encontrado.")
            return
        }

        if (!idOpcao) {
            setCategorias(prev => {
                const updatedCategorias = [...prev]
                updatedCategorias[categoriaIndex].produtos[produtoIndex].opcoes[
                    passoIndex
                ].opcoes.splice(index, 1)
                return updatedCategorias
            })
            return
        }

        setLoading(true)

        const data = { id: idOpcao }

        const response = await excluirOpcao(data, autorizacao)

        if (response.retornoErro) {
            setLoading(false)
            alertStart(response.mensagem, "error")
            console.error(response)
        } else {
            setCategorias(prev => {
                const updatedCategorias = [...prev]
                updatedCategorias[categoriaIndex].produtos[produtoIndex].opcoes[passoIndex].opcoes =
                    updatedCategorias[categoriaIndex].produtos[produtoIndex].opcoes[
                        passoIndex
                    ].opcoes.filter(o => o.id !== idOpcao)
                return updatedCategorias
            })
            console.warn("ExcluirOpcao => ", response)
            alertStart("Opção de montagem excluída com sucesso", "success")
        }
        setLoading(false)
    }

    const idsSet = new Set()
    const handleIdsEditar = idProduto => {
        idsSet.add(idProduto)
        idsSave = Array.from(idsSet)
    }

    const atualizarConfiguracoes = useAppStore(s => s.atualizarConfiguracoes)
    const configuracoes = useAppStore(s => s.configuracoes)

    const [sincronizar99Handler, setSincronizar99Handler] = useState()

    const [salvarCardapio, setSalvarCardapioCompleto] = useState(false)

    const handleSalvarCardapioInteiro = async () => {
        if (idsSave.length >= 1 || salvarCardapio) {
            setLoading(true)
            let data = null

            if (salvarCardapio) {
                data = cardapio
            } else {
                data = {
                    ...cardapio,
                    categorias: categorias
                        .map(categoria => {
                            const produtosFiltrados = categoria.produtos.filter(produto =>
                                idsSave.includes(produto.id)
                            )

                            if (produtosFiltrados.length > 0) {
                                return {
                                    ...categoria,
                                    produtos: produtosFiltrados,
                                }
                            }
                            return null
                        })
                        .filter(categoria => categoria !== null),
                }
            }
            const response = await salvarCardapioCompleto(estabelecimento.id, data, autorizacao)
            if (response.retornoErro) {
                console.error(response)
                alertStart(response.mensagem, "error")
            } else {
                console.warn("salvarCardapioCompleto => ", response)
                alertStart("Cardapio salvo com sucesso", "success")
            }

            idsSet.clear()
            setSalvarCardapioCompleto(false)
            setLoading(false)
        } else {
            return
        }
    }

    const handleCadastrarImagem = async (
        nomeArquivo,
        idProduto,
        idPasso,
        idOpcao,
        file,
        edicaoMassa
    ) => {
        if (idProduto === null && idPasso === null && idOpcao === null) {
            setLoading(true)
            try {
                const response = await cadastrarImagem(
                    estabelecimento.id,
                    nomeArquivo,
                    idProduto,
                    idOpcao,
                    file,
                    autorizacao
                )
                if (response.retornoErro) {
                    console.error(response)
                    alertStart(response.mensagem, "error")
                } else {
                    return response.valor
                }
            } catch (error) {
                console.error(error)
            } finally {
                setLoading(false)
            }
        }

        const categoriaIndex =
            typeof idProduto === "string"
                ? categorias.findIndex(categoria =>
                      categoria.produtos.some(produto => produto.nome === idProduto)
                  )
                : categorias.findIndex(categoria =>
                      categoria.produtos.some(produto => produto.id === idProduto)
                  )
        if (categoriaIndex === -1) {
            console.error("Categoria não encontrada.")
            return
        }

        const produtoIndex =
            typeof idProduto === "string"
                ? categorias[categoriaIndex].produtos.findIndex(
                      produto => produto.nome === idProduto
                  )
                : categorias[categoriaIndex].produtos.findIndex(produto => produto.id === idProduto)
        if (produtoIndex === -1) {
            console.error("Produto não encontrado.")
            return
        }

        const passoIndex = idPasso
            ? categorias[categoriaIndex].produtos[produtoIndex].opcoes.findIndex(
                  passo => passo.id === idPasso
              )
            : null
        if (passoIndex === -1) {
            console.error("Passo não encontrado.")
            return
        }

        const opcaoIndex = idOpcao
            ? categorias[categoriaIndex]?.produtos[produtoIndex]?.opcoes[
                  passoIndex
              ]?.opcoes.findIndex(opcao => opcao.id === idOpcao)
            : null
        if (opcaoIndex === -1) {
            console.error("Passo não encontrado.")
            return
        }

        try {
            setLoading(true)
            const response = await cadastrarImagem(
                estabelecimento.id,
                nomeArquivo,
                idProduto,
                idOpcao,
                file,
                autorizacao
            )
            if (response.retornoErro) {
                console.error(response)
                alertStart(response.mensagem, "error")
            } else {
                if (idOpcao) {
                    if (edicaoMassa) {
                        return response.valor
                    } else {
                        setCategorias(prev => {
                            prev[categoriaIndex].produtos[produtoIndex].opcoes[passoIndex].opcoes[
                                opcaoIndex
                            ].urlImagem = response.valor
                            return [...prev]
                        })
                    }
                } else {
                    if (edicaoMassa) {
                        return response.valor
                    } else {
                        setCategorias(prev => {
                            prev[categoriaIndex].produtos[produtoIndex].urlImagem = response.valor
                            return [...prev]
                        })
                    }
                }
                console.warn("salvarCardapioCompleto => ", response)
                alertStart("Imagem atualizada com sucesso", "success")
            }
        } catch (error) {
            console.error(error)
        } finally {
            setLoading(false)
        }
    }

    const [insumoSelecionado, setInsumoSelecionado] = useState(null)
    const [insumosSelecionados, setInsumosSelecionados] = useState([])
    const [fichaTecnica, setFichaTecnica] = useState(null)
    const [quantidades, setQuantidades] = useState({})
    const [altInsumo, setAltInsumo] = useState(false)
    const [produto, setProduto] = useState(false)

    const buscarFT = async (tipo, idProduto, idOpcao) => {
        try {
            setLoading(true)
            if (tipo === "produto") {
                const response = await buscarFichaTecnicaProduto(
                    estabelecimento.id,
                    idProduto,
                    autorizacao
                )
                if (response.retornoErro === 1) {
                    setFichaTecnica(null)
                } else {
                    setFichaTecnica(response)
                    setProduto(true)
                }

                const quantidadesIniciais = {}
                response?.insumos?.forEach(insumo => {
                    quantidadesIniciais[insumo.id] = insumo.quantidade ?? null
                })
                setQuantidades(quantidadesIniciais)
            } else if (tipo === "opcao") {
                const response = await buscarFichaTecnicaOpcao(
                    estabelecimento.id,
                    idOpcao,
                    autorizacao
                )
                if (response.retornoErro === 1) {
                    setFichaTecnica(null)
                    setProduto(false)
                } else {
                    setFichaTecnica(response)
                }

                const quantidadesIniciais = {}
                response?.insumos?.forEach(insumo => {
                    quantidadesIniciais[insumo.id] = insumo.quantidade ?? null
                })
                setQuantidades(quantidadesIniciais)
            }
        } catch (error) {
            alertStart("Erro ao buscar ficha técnica", "error")
        } finally {
            setLoading(false)
        }
    }

    const handleAddInsumo = () => {
        setAltInsumo(true)
        if (!insumoSelecionado) return

        if (fichaTecnica) {
            const exists = fichaTecnica.insumos?.some(i => i.id === insumoSelecionado.id)
            if (!exists) {
                setFichaTecnica(prev => ({
                    ...prev,
                    insumos: [...prev.insumos, insumoSelecionado],
                }))
                setQuantidades(prev => ({ ...prev, [insumoSelecionado.id]: null }))
            }
        } else {
            const exists = insumosSelecionados.some(i => i.id === insumoSelecionado.id)
            if (!exists) {
                setInsumosSelecionados(prev => [...prev, insumoSelecionado])
                setQuantidades(prev => ({ ...prev, [insumoSelecionado.id]: null }))
            }
        }

        setInsumoSelecionado(null)
    }

    const handleDeleteInsumo = idInsumo => {
        setAltInsumo(true)
        if (fichaTecnica) {
            setFichaTecnica(prev => ({
                ...prev,
                insumos: prev?.insumos?.filter(i => i.id !== idInsumo),
            }))
        } else {
            setInsumosSelecionados(prev => prev?.filter(i => i.id !== idInsumo))
        }

        setQuantidades(prev => {
            const nova = { ...prev }
            delete nova[idInsumo]
            return nova
        })
    }

    const montarDataFichaTecnica = (idProduto, idOpcao) => {
        const insumosFinal = (fichaTecnica ? fichaTecnica?.insumos : insumosSelecionados).map(
            insumo => ({
                id: insumo.id,
                quantidade: quantidades[insumo.id]?.toString() ?? null,
            })
        )

        const data = {
            insumos: insumosFinal,
        }

        if (idProduto) {
            data.produtoId = idProduto
        } else if (idOpcao) {
            data.opcaoId = idOpcao
        }

        return data
    }

    const salvarFt = async (idProduto, idOpcao) => {
        if (!altInsumo) return

        try {
            setLoading(true)
            if (fichaTecnica) {
                const response = await atualizarFichaTecnica(
                    estabelecimento.id,
                    fichaTecnica?.id,
                    montarDataFichaTecnica(idProduto, idOpcao),
                    autorizacao
                )
                if (response.retornoErro === 1) {
                    alertStart(response.mensagem, "error")
                } else {
                    alertStart("Ficha técnica atualizada com sucesso", "success")
                }
            } else {
                const response = await salvarFichaTecnica(
                    estabelecimento.id,
                    montarDataFichaTecnica(idProduto, idOpcao),
                    autorizacao
                )
                if (response.retornoErro === 1) {
                    alertStart(response.mensagem, "error")
                } else {
                    alertStart("Ficha técnica cadastrada com sucesso", "success")
                }
            }
        } catch (error) {
            alertStart("Erro: " + error, "error")
        } finally {
            setInsumosSelecionados([])
            setLoading(false)
        }
    }

    return (
        <Grid>
            <Cabecalho pagina={"Edição de Cardápio"} telasEdicao />
            <Sincronizacao99Context.Provider
                value={{
                    sincronizar99Handler,
                    setSincronizar99Handler,
                }}
            >
                <div className={classes.container}>
                    {tela === "produtos" ? (
                        <NovaTelaProdutos
                            cardapio={cardapio}
                            estabelecimento={estabelecimento}
                            cadastrar={cadastrar}
                            setCadastrar={setCadastrar}
                            categorias={categorias}
                            setCategorias={setCategorias}
                            handleSalvarCategoria={handleSalvarCategoria}
                            handleSalvarProduto={handleSalvarProduto}
                            handleDuplicarCategoria={handleDuplicarCategoria}
                            handleDuplicarProduto={handleDuplicarProduto}
                            handleDuplicarPassoDeMontagem={handleDuplicarPassoDeMontagem}
                            handleExcluirCategoria={handleExcluirCategoria}
                            handleExcluirProduto={handleExcluirProduto}
                            handleCadastrarGrupoDeOpcao={handleCadastrarGrupoDeOpcao}
                            handleExcluirGrupoDeOpcao={handleExcluirGrupoDeOpcao}
                            handleCadastrarOpcao={handleCadastrarOpcao}
                            handleExcluirOpcao={handleExcluirOpcao}
                            handleSalvarCardapioInteiro={handleSalvarCardapioInteiro}
                            handleIdsEditar={handleIdsEditar}
                            idsSet={idsSet}
                            handleCadastrarImagem={handleCadastrarImagem}
                            setSalvarCardapioCompleto={setSalvarCardapioCompleto}
                            insumos={insumos}
                            insumoSelecionado={insumoSelecionado}
                            insumosSelecionados={insumosSelecionados}
                            fichaTecnica={fichaTecnica}
                            quantidades={quantidades}
                            handleAddInsumo={handleAddInsumo}
                            handleDeleteInsumo={handleDeleteInsumo}
                            salvarFt={salvarFt}
                            setInsumoSelecionado={setInsumoSelecionado}
                            setQuantidades={setQuantidades}
                            setAltInsumo={setAltInsumo}
                            buscarFT={buscarFT}
                            produto={produto}
                        />
                    ) : tela === "massa" ? (
                        <CheckboxProvider>
                            <EdicaoEmMassa
                                items={items}
                                setItems={setItems}
                                estabelecimento={estabelecimento}
                                handleCadastrarImagem={handleCadastrarImagem}
                            />
                        </CheckboxProvider>
                    ) : tela === "insumos" ? (
                        <Inusmos insumos={insumos} setInsumos={setInsumos} cardapio={cardapio} />
                    ) : tela === "ficha-tecnica" ? (
                        <FichaTecnica
                            FTEstabelecimento={FTEstabelecimento}
                            setFTEstabelecimento={setFTEstabelecimento}
                            insumos={insumos}
                            cardapio={cardapio}
                        />
                    ) : null}
                </div>
            </Sincronizacao99Context.Provider>
        </Grid>
    )
}
